import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";

import React, { useEffect, useState } from "react";
import { getUserData } from "../../utils/localStorage";
import {
  getStoreRiderInfo,
  getStoreTimeSlot,
  postDeliveryRequest,
  updateDeliveryRequest,
} from "../../services/StoreRiderInfo/StoreRiderInfo";
import { getCustomerOrders } from "../../services/CustomerInfo/CustomerInfo";
import { formatDate } from "../../constants/DateUtil/DateUtil";

const { innerWidth: width, innerHeight: height } = window;

const DeliveryRequest = ({
  deliveryRequestModalVisible,
  setDeliveryRequestModalVisible,
  status,
  text,
  storeId,
  storeCustomerId,
  editMode,
  sendResponse,
  pickupDeliveryRequestData,
}) => {
  const { userProfileRole } = getUserData();
  const {
    storeCustomerId: pickupDeliveryStoreCustomerId,
    storeUserId,
    pickupDeliveryTimeSlot,
    pickupOn,
    riderName,
    orderId,
    pickupDeliveryStatus,
    orderNo,
    invoiceNo,
    createdDate,
  } = pickupDeliveryRequestData;

  let initialDate = new Date();
  let editModeDate = initialDate;
  if (editMode) {
    let pickupOnDate = new Date(pickupOn).getTime();
    let today = new Date().getTime();
    let msDay = 24 * 60 * 60 * 1000; // milliseconds per day
    let days = Math.floor((today - pickupOnDate) / msDay);

    if (days < 0) {
      editModeDate = pickupOn;
    }
  }
  const [riderInfo, setRiderInfo] = useState([]);
  const [orderInfoData, setOrderInfoData] = useState([]);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(editMode ? pickupDeliveryTimeSlot : "");
  // const [assignRiderValue, setAssignRiderValue] = useState(
  //  editMode ? {name: riderName, code: storeUserId} : ""
  // );

  const [assignRiderValue, setAssignRiderValue] = useState("");
  const [orderInfoValue, setOrderInfoValue] = useState(editMode ? orderId : "");

  const [timeSlotData, setTimeSlotData] = useState([]);
  const [date, setDate] = useState(new Date(editModeDate));
  const [selectedCity, setSelectedCity] = useState(null);

  const [timeSlotError, setTimeSlotError] = useState("");
  const [assignRiderError, setAssignRiderError] = useState("");
  const [orderInfoError, setOrderInfoError] = useState("");
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date


  const fetchCustomerOrders = () => {
    if (editMode) {
      storeCustomerId = pickupDeliveryStoreCustomerId;
    }
    const data = {
      offset: 0,
      limit: 100,
      statusIn: [
          "PROCESSED",
      ],
      deliveryRequestStatus : 'no',
    }
    getCustomerOrders(storeCustomerId, storeId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          // const reverseData = Res;
          // const filteredData = reverseData.filter(
          //   (item) => item.status === "PROCESSED" && !item.deliveryRequest
          // );
          const filterRes = Res.map((item) => ({
            name:
              "Invoice No. " +
              item.invoiceNo +
              " - " +
              formatDate(item.createdDate),
            code: item.id,
          }));

          setOrderInfoData(filterRes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreRiderInfo = () => {
    getStoreRiderInfo(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const filterRes = Res.map((item) => ({
            name: item.firstName + item.lastName,
            code: item.id,
          }));
          setRiderInfo(filterRes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchStoreRiderTimeSlot = (currentTime) => {
    getStoreTimeSlot(storeId, currentTime)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setTimeSlotData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchCustomerOrders();
    fetchStoreRiderInfo();
    const currentTime = new Date();
    if (currentTime >= new Date()) {
      fetchStoreRiderTimeSlot(currentTime.getHours());
    } else {
      setSelectedTimeSlot([]);
    }
  }, []);

  const handleModalClose = () => {
    setDeliveryRequestModalVisible(false);
    setSelectedTimeSlot("");
    setAssignRiderValue("");
    setOrderInfoError("");
    setOrderInfoValue([])
  };

  const handleDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {
      // Prevent selection of past dates
      // if (selectedDate >= new Date()) {

      const utcDate = new Date(
        Date.UTC(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate()
        )
      );

        setDate(utcDate);

        if (utcDate >= new Date()) {
          fetchStoreRiderTimeSlot(utcDate.getHours());
        } else {
          setSelectedTimeSlot([]);
        }
      // }
    }
  };

  const onNextButtonPress = () => {
    if (selectedTimeSlot.length <= 0) {
      setTimeSlotError("Please Chose Correct Pickup Date And Time");
    } else if (assignRiderValue === "") {
      setAssignRiderError("Please Select any Rider");
    } else if (orderInfoValue == "") {
      setOrderInfoError("Please Select any Order");
    } else {
      const newDate = new Date(date);
          newDate.setSeconds(newDate.getSeconds() + 1);
    const currentDateTime = newDate.toISOString();

      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);
        if (editMode) {
          // Logic for updating a pickup request

          const updatedPickupRequest = {
            id: pickupDeliveryRequestData.id,
            storeId: storeId,
            storeCustomerId: pickupDeliveryStoreCustomerId,
            storeUserId: assignRiderValue.code,
            order: {
              id: orderInfoValue.code,
            },
            deliveryTimeSlot: selectedTimeSlot,
            // deliveryOn: new Date(utcDate).toISOString(),
            deliveryOn: currentDateTime,
            deliveryStatus: pickupDeliveryStatus,
          };
          // Call the service function for updating pickup request
          updateDeliveryRequest(
            pickupDeliveryStoreCustomerId,
            storeId,
            updatedPickupRequest
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  sendResponse({
                    message,
                    status,
                    modalFun: false,
                  });
                  // Reset state variables
                  setSelectedTimeSlot("");
                  setAssignRiderValue("");
                  setOrderInfoError("");
                  setIsSubmitButtonPressed(false);
                  setDeliveryRequestModalVisible(false);
                  setOrderInfoValue([])
                  fetchCustomerOrders();
                }
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        } else {
          // Logic for creating a new pickup request

          const newDeliveryRequest = {
            storeId: storeId,
            storeCustomerId: storeCustomerId,
            storeUserId: assignRiderValue.code,
            order: {
              id: orderInfoValue.code,
            },
            deliveryTimeSlot: selectedTimeSlot,
            // deliveryOn: new Date(utcDate).toISOString(),
            deliveryOn: currentDateTime,
          };
          // Call the service function for creating pickup request
          postDeliveryRequest(storeCustomerId, storeId, newDeliveryRequest)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  const message = Res.message;
                  const status = Res.status;
                  sendResponse({ message, status, modalFun: false });
                  // Reset state variables
                  setSelectedTimeSlot("");
                  setAssignRiderValue("");
                  setOrderInfoError("");
                  setIsSubmitButtonPressed(false);
                  setDeliveryRequestModalVisible(false);
                  setOrderInfoValue([])
                  fetchCustomerOrders();
                }
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    }
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={deliveryRequestModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!deliveryRequestModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: height < 600 ? 50 : 60,
                  width: height < 600 ? 50 : 60,
                  // alignSelf: 'center',
                }}
                src={
                  "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Deliver_Request.gif"
                }
              />

              <p className=" text-3xl text-primary-50 font-semibold">
                Delivery Request
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div className="flex-auto mx-4">
              <p className="font-bold block mb-2 ml-2">Delivery Date</p>
              <Calendar
                id="buttondisplay"
                value={date}
                onChange={(e) => handleDateChange(e.value)}
                showIcon
                minDate={new Date()}
                maxDate={maximumDate}
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-md text-primary-50"
                dateFormat="dd/mm/yy"
              />
            </div>

            <div className="inline-flex flex-column gap-2 mx-4">
              <Dropdown
                value={selectedTimeSlot}
                onChange={(e) => setSelectedTimeSlot(e.value)}
                options={timeSlotData}
                placeholder="Select Delivery Time"
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-md text-primary-50"
              />
            </div>
            {timeSlotError && (
              <div className="inline-flex flex-column gap-2 mx-4">
                <p
                  className="font-normal text-lg block"
                  style={{ color: "red" }}
                >
                  {timeSlotError}
                </p>
              </div>
            )}
            {userProfileRole === "BY_STORE" ||
            userProfileRole === "BY_ADMIN" ||
            userProfileRole === "BY_SUB_ADMIN_USER" ? (
              <div className="inline-flex flex-column gap-2 mx-4">
                <Dropdown
                  value={assignRiderValue}
                  onChange={(e) => setAssignRiderValue(e.value)}
                  options={riderInfo}
                  optionLabel="name"
                  placeholder="Assign Rider"
                  className="w-full  bg-white-alpha-20 border-round-lg p-1 text-md text-primary-50"
                />
              </div>
            ) : (
              <div className="inline-flex flex-column gap-2 mx-4">
                <p className="text-primary-50 font-semibold">Rider Info</p>
                <InputText
                  value={riderName}
                  disabled
                  id="username"
                  label="Username"
                  className="w-full  bg-white-alpha-20 border-round-lg p-1 text-md text-primary-50"
                ></InputText>
              </div>
            )}
            {assignRiderValue === "" && assignRiderError && (
              <div className="flex-auto">
                <p
                  className="font-normal text-lg block mb-2 mx-4"
                  style={{ color: "red" }}
                >
                  {assignRiderError}
                </p>
              </div>
            )}

            {!editMode ? (
              <div className="inline-flex flex-column gap-2 mx-4">
                <Dropdown
                  value={orderInfoValue}
                  onChange={(e) => setOrderInfoValue(e.value)}
                  options={orderInfoData}
                  optionLabel="name"
                  placeholder="Order Info "
                  className="w-full  bg-white-alpha-20 border-round-lg p-1 text-md text-primary-50"
                />
              </div>
            ) : (
              <div className="inline-flex flex-column gap-2 mx-4">
                <p className="text-lg font-semibold">Order Info</p>
                <InputText
                  value={`Invoice No. ${invoiceNo} - ${createdDate}`}
                  disabled
                  id="username"
                  label="Username"
                  className="w-full  border-round-lg p-3 text-md"
                  style={{ color: "#000" }}
                ></InputText>
              </div>
            )}
            {orderInfoError && (
              <div className="flex-auto">
                <p
                  className="font-normal text-lg block mb-2 mx-4"
                  style={{ color: "red" }}
                >
                  {orderInfoError}
                </p>
              </div>
            )}

            {orderInfoData.length <= 0 && !editMode && (
              <div className="inline-flex flex-column mx-4">
                <p
                  className="font-normal text-lg block"
                  style={{ color: "red" }}
                >
                  There is no order to select
                </p>
              </div>
            )}

            <Button
              disabled={isSubmitButtonPressed}
              onClick={onNextButtonPress}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-xl font-semibold flex justify-content-center">
                Submit Request
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default DeliveryRequest;
